import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgPicCircleCopySelected({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 56 56"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <g fill="none" fillRule="evenodd">
        <circle fill="#56A" opacity={0.88} cx={28} cy={28} r={28} />
        <path
          d="M10.01 49.4V20L16 14h23.61v39.13c-10.11 2.64-17.98 2.7-23.6.18a26.15 26.15 0 01-6-3.9z"
          fill="#FFF"
        />
        <path fill="#8F9DD6" d="M14.01 52.26V24L20 18h19.61v33L16 53.3z" />
        <path
          d="M45.61 20v29.77A27.88 27.88 0 0128 56a27.9 27.9 0 01-11.99-2.69V26L22 20h23.61z"
          fill="#FFF"
        />
        <path
          d="M29.55 39.78v2.43H18.98v-2.43h10.57zm13.13-4.96v2.43h-5.37v-2.43h5.37zm-9.3-.04v2.43H18.94v-2.43h14.42zm9.3-4.75v2.44h-5.37v-2.44h5.37zm-9.3-.03v2.43H18.94V30h14.42zM16 26l6-6v6zm0-12v6h-6z"
          fill="#8F9DD6"
        />
      </g>
    </svg>
  );
}

SvgPicCircleCopySelected.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgPicCircleCopySelected.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgPicCircleCopySelected svgRef={ref} {...props} />
));
export default ForwardRef;
